import { render, staticRenderFns } from "./DataTableEmp.vue?vue&type=template&id=68c5b7db&scoped=true"
import script from "./DataTableEmp.vue?vue&type=script&lang=js"
export * from "./DataTableEmp.vue?vue&type=script&lang=js"
import style0 from "./DataTableEmp.vue?vue&type=style&index=0&id=68c5b7db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c5b7db",
  null
  
)

export default component.exports